import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Animation from "./Animation";

export default class HTPClickAnyAnimation extends Animation {
  constructor(ClickAnyCon: PIXI.Container, scale: number, onComp: () => void) {
    super();
    new Tween.Tween(ClickAnyCon.scale)
      .to({ x: scale, y: scale }, 700)
      .easing(Tween.Easing.Linear.None)
      .onComplete(() => onComp())
      .start();

  }
}